import { render } from "./LoginDesktop.vue?vue&type=template&id=771aa408&scoped=true"
import script from "./LoginDesktop.vue?vue&type=script&lang=js"
export * from "./LoginDesktop.vue?vue&type=script&lang=js"

import "./LoginDesktop.vue?vue&type=style&index=0&id=771aa408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771aa408"]])

export default __exports__